import React from 'react';
import PlaylistPanelItem from './PlaylistPanelItem';

function PlaylistPanelList({
  playlistOrderMap,
  setPlaylistOrderMap,
  selectedPlaylistId,
  playlistItems,
  dragOverIndex,
  handleItemDragOver,
  handleItemDragLeave,
  handleItemDrop
}) {
   const items = playlistOrderMap[selectedPlaylistId] || playlistItems || [];
  if (items.length === 0) {
    return (
      <div className="text-center text-muted" style={{ marginTop: 40 }}></div>
    );
  }
  return (
    <div className="flex-scroll pb-3" style={{ height: 200, overflowY: 'auto' }}>
      <ul className="list-group">
        {(playlistOrderMap[selectedPlaylistId] || playlistItems || [])?.map((item, idx) => (
          <PlaylistPanelItem
            key={item.id || idx}
            item={item}
            idx={idx}
            dragOverIndex={dragOverIndex}
            onDragOver={handleItemDragOver}
            onDragLeave={handleItemDragLeave}
            onDrop={handleItemDrop}
            playlistOrderMap={playlistOrderMap}
            setPlaylistOrderMap={setPlaylistOrderMap}
            selectedPlaylistId={selectedPlaylistId}
            playlistItems={playlistItems}
          />
        ))}
      </ul>
    </div>
  );
}

export default PlaylistPanelList;
